import React from 'react';
import skinsStyles from './styles/BoxScreen.scss';
import BaseScreenSkin, { BaseScreenSkinProps } from './BaseScreenSkin';

const BoxScreen: React.FC<Omit<
  BaseScreenSkinProps,
  'skin' | 'skinsStyle'
>> = props => <BaseScreenSkin {...props} skinsStyle={skinsStyles} />;

export default BoxScreen;
